// extracted by mini-css-extract-plugin
export default {"formSpaceContent":"RelatedAccounts_formSpaceContent__SlLXF","label":"RelatedAccounts_label__OwqMT","value":"RelatedAccounts_value__iYqQc"};